import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  ref: "subjectRunDataPreferences",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  "aria-labelledby": "staticBackdropLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Run Data Preferences for Subject")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "alert alert-primary text-center" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode(" Do you want QuickSource to populate your "),
    /*#__PURE__*/_createElementVNode("b", null, [
      /*#__PURE__*/_createElementVNode("u", null, "empty")
    ]),
    /*#__PURE__*/_createTextVNode(" Subject fields based on your data preferences? ")
  ])
], -1)
const _hoisted_6 = ["checked"]
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Do not automatically fill out the Subject ")
const _hoisted_8 = ["checked"]
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Run the data preference to fill out ")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("b", null, [
  /*#__PURE__*/_createElementVNode("u", null, "empty")
], -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" data fields for the Subject ")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "mt-3" }, [
  /*#__PURE__*/_createTextVNode("If you change your mind, click the "),
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lock ml-2 mr-2" }),
  /*#__PURE__*/_createTextVNode(" or "),
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lock-open ml-2 mr-2" }),
  /*#__PURE__*/_createTextVNode(" icons in the "),
  /*#__PURE__*/_createElementVNode("i", null, "Transfer to Form"),
  /*#__PURE__*/_createTextVNode(" column to update this setting.")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-outline-secondary",
  "data-bs-dismiss": "modal"
}, "Cancel", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalHeader = _resolveComponent("ModalHeader")!
  const _component_ModalBody = _resolveComponent("ModalBody")!
  const _component_ModalFooter = _resolveComponent("ModalFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ModalHeader, null, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_ModalBody, null, {
          default: _withCtx(() => [
            _hoisted_5,
            _createElementVNode("div", null, [
              _createElementVNode("div", null, [
                _createElementVNode("label", null, [
                  _createElementVNode("input", {
                    class: "pt-1 mr-2 radio-button",
                    type: "radio",
                    name: "cascadeLock",
                    value: "true",
                    checked: this.subjectCascadeDisabled === true
                  }, null, 8, _hoisted_6),
                  _hoisted_7
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", null, [
                  _createElementVNode("input", {
                    class: "pt-1 mr-2 radio-button",
                    type: "radio",
                    name: "cascadeLock",
                    value: "false",
                    checked: this.subjectCascadeDisabled === false
                  }, null, 8, _hoisted_8),
                  _hoisted_9,
                  _hoisted_10,
                  _hoisted_11
                ])
              ]),
              _hoisted_12
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_ModalFooter, null, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.save()))
            }, "Save"),
            _hoisted_13
          ]),
          _: 1
        })
      ])
    ])
  ], 512))
}